import type { JSX } from 'react';
import { useQuery } from '@tanstack/react-query';

import { PageTitle } from '../components/ds';
import { VerifyQueueTab } from '../components/VerifyQueueTab';
import { analyticsApi } from '../lib/api/admin';

/**
 * «Актуальность базы» (/admin/freshness) — пункт меню УК «Управление».
 * Тот же экран — вкладка «Актуальность» в «Аналитике»: очереди просрочено /
 * истекает / без владельца / актуальны / кандидаты в архив. Владелец получает
 * напоминание за 7 дней до срока и после него (крон wiki-verify-reminder).
 */
export function FreshnessPage(): JSX.Element {
  const q = useQuery({ queryKey: ['wiki-admin', 'verify-queue'], queryFn: () => analyticsApi.verifyQueue() });
  const c = q.data?.counts;
  const freshPct = c?.total ? Math.round(((c.fresh ?? 0) / c.total) * 100) : null;
  return (
    <div style={{ maxWidth: 1240 }}>
      <PageTitle
        title="Актуальность базы"
        sub={
          c?.total != null
            ? `${c.total.toLocaleString('ru-RU')} статей · ${freshPct ?? 0} % актуальны · проверка по сроку владельца`
            : 'Что просрочено, у чего срок на подходе и где не назначен владелец'
        }
      />
      <VerifyQueueTab />
    </div>
  );
}
